import { useBrandMarkAssets } from "@/components/branding/use-brand-mark-assets.js";

export function BrandTableLoadingMark() {
    const { logoSrc, defaultLogo, defaultText, productLabel, useWordmarkImage } = useBrandMarkAssets();

    return (
        <div className="flex items-center gap-3" data-slot="brand-table-loading">
            <img
                src={logoSrc}
                alt=""
                className="sgrc-logo-mark size-10 shrink-0 animate-spin object-contain motion-reduce:animate-none"
                onError={(e) => {
                    e.currentTarget.src = defaultLogo;
                }}
            />
            {useWordmarkImage ? (
                <img
                    src={defaultText}
                    alt="sGRC"
                    className="sgrc-logo-text h-6 w-auto max-w-[7rem] object-contain"
                />
            ) : (
                <span className="text-sm font-semibold text-foreground">
                    {productLabel}
                </span>
            )}
        </div>
    );
}
